import React from "react";
import PropTypes from "prop-types";
import { descriptorPropTypes } from "lib/common/descriptorcontrols/formhelpers";
import EntityProxy from "data/util/EntityProxy";
import Kids from "lib/dataentry/lib/dataentryform/formitems/Kids";

export class Formform extends React.Component {
    constructor(props) {
        super(props);
        this.onKeyDown = this.onKeyDown.bind(this);
    }

    onKeyDown(e) {
        if(e.key === "Enter" || e.key === "Tab") {
            // Don't submit or save on "enter" key down.
            // Yes allow propagation for DropdownWrapper portal.
            e.preventDefault();
        }
    }

    render() {
        const {
            selector,
            fluxContext,
            activeRecord,
            descriptor,
            onBlur,
            onFocus,
            onKeyDown,
            onGlobalRecordLookup,
        } = this.props;
        return (
            <form
                id={descriptor.id}
                data-title={descriptor.label}
                onKeyDown={this.onKeyDown}
            >
                <div className={selector}>
                    <Kids descriptor={descriptor}
                          fluxContext={fluxContext}
                          activeRecord={activeRecord}
                          onFocus={onFocus}
                          onBlur={onBlur}
                          onKeyDown={onKeyDown}
                          onGlobalRecordLookup={onGlobalRecordLookup}
                    />
                </div>
            </form>
        );
    }
}

Formform.propTypes = {
    descriptor: PropTypes.shape(descriptorPropTypes(null, false, true)),
    fluxContext: PropTypes.string.isRequired,
    activeRecord: PropTypes.instanceOf(EntityProxy).isRequired,
    selector: PropTypes.string,
    onFocus: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    onKeyDown: PropTypes.func.isRequired,
    onGlobalRecordLookup: PropTypes.func.isRequired,
};

export default Formform;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/Form/form.js